<template>
  <pulldown-page class="page" :background="background" color="#333333" :refresh="pulldown">
    <navigation />
    <div class="result-mp" v-show="pageShow">
      <!-- 授信审核中 -->
      <div class="refused" v-show="['CREDIT_REVIEW'].includes(creditStatus)">
        <div class="animation-wapper">
          <lottie ref="animataionLoading" :options="showGif[0]" v-on:animCreated="handleAnimation" />
        </div>

        <h1>授信审核中</h1>
        <p>我们正在加急为您审核，请您耐心等待</p>
        <button @click="backHome">返回首页</button>
      </div>
      <div v-show="!['CREDIT_REVIEW'].includes(creditStatus)">
        <template v-if="showGuide==='N'">
          <!-- 授信未通过 -->
          <div class="refused" v-if="['CREDIT_ERROR', 'CREDIT_EXPIRE', 'CREDIT_REFUSED','PRE_REFUSED'].includes(creditStatus)">
            <div class="animation-wapper">
              <lottie ref="animataionFail" :options="showGif[1]" v-on:animCreated="handleAnimation" />
            </div>
            <h1>授信未通过</h1>
            <p v-if="!reapplyTime">
              很遗憾，您的授信申请暂未通过<br />请稍后重试
            </p>
            <p v-else>
              很遗憾，您的授信申请暂未通过<br />您可以于
              <span class="highlight">{{
                reapplyTime && reapplyTime.replace(/-/g, "/")
              }}</span>
              发起重试
            </p>
            <button @click="backHome">返回首页</button>
          </div>

          <!-- 授信通过 -->
          <div class="pass" v-else-if="['CREDIT_SUCCESS'].includes(creditStatus)">
            <div class="card">
              <img src="./images/img_tongguo@2x.png" />
              <h1 class="underline">恭喜您，</h1>
              <h1>
                获得额度<span class="bold">{{ creditLimit | currency }}</span>
              </h1>
              <p>放款快，利率低，立即发起提现吧</p>
              <nd-button class="solid-button" @click="navigateToWithdraw">立即提现</nd-button>
              <button class="text-button" @click="backHome">
                返回首页
              </button>
            </div>
          </div>
        </template>

        <!-- 引导下载结果 -->
        <div class="guide-result" v-else>
          <div class="card">
            <div class="animation-wapper">
              <!-- <lottie ref="animataion" :options="showGif[2]" v-on:animCreated="handleAnimation" /> -->
              <img src="./images/mp_success.png" class="mp_success">
            </div>
            <template v-if="['CREDIT_SUCCESS'].includes(creditStatus)">
              <h1>恭喜您获得{{ creditLimit | currency }}元循环额度</h1>
              <p>额度有效期<span class="red">60天</span></p>
            </template>
            <template v-else>
              <h1>成功获得最高50000元额度</h1>
            </template>
          </div>
          <div class="info">
            <div class="header">
              <!-- <img src="./images/icon_xiafa@2x.png" />  -->
              <template v-if="['CREDIT_SUCCESS'].includes(creditStatus)">您的额度即将下发</template>
              <template v-else>您的初审额度即将下发</template>
            </div>
            <div class="info-list">
              <div class="item">
                <div class="label"><b>产品详情</b></div>
              </div>
              <div class="item">
                <div class="label">借款利率</div>
                <div class="value">年化利率12%-24%</div>
              </div>
              <div class="item">
                <div class="label">分期期限</div>
                <div class="value">最长12期</div>
              </div>
              <div class="item">
                <div class="label">还款规则</div>
                <div class="value">随借随还，按日计息</div>
              </div>
            </div>
            <nd-button type="primary" class="btn" @click="guideDownload">
              <template v-if="['CREDIT_SUCCESS'].includes(creditStatus)">立即提现，匹配更优资方</template>
              <template v-else>立即拿额度</template>
            </nd-button>
          </div>
          <img src="./images/mp_tips.png" class="bottom-info" />
        </div>
      </div>
      <download-dialog ref="downloadDialog"></download-dialog>
  
      <!-- <nd-dialog class="question-dialog" v-model="questionDialog" :closeBtn="true" @click="questionDialog = false" :footer="false">
        <div class="question">
          <div class="copy-btn" @click="copyUrlAndToast" data-sensors-click>
            <img src="./images/icon_lianjie@2x.png" />
            <span>复制下载链接</span>
          </div>
        </div>
      </nd-dialog>
      <ios-download v-model="downloadVisible"></ios-download> -->
    </div>
  </pulldown-page>
</template>
<script>
import { mapActions } from 'vuex'
import Lottie from 'vue-lottie'
import IosDownload from '@/components/ios-download'
import { fail, wait, success } from '@/assets/json/index'
import downloadDialog from '@/components/download-dialog'
import wx from 'weixin-webview-jssdk'
export default {
  components: { Lottie, IosDownload, downloadDialog },
  data () {
    return {
      background: '#f5f5f5',
      applyNo: this.$route.query.applyNo,
      reapplyTime: null,
      creditLimit: '',
      creditStatus: 'CREDIT_REVIEW',
      downloadVisible: false,
      questionDialog: false,
      pageShow: false,
      personType: this.$route.query.personType,
      showGif: [
        { animationData: wait },
        { animationData: fail, loop: false },
        { animationData: success, loop: false }
      ],
      showGuide: 'N'
    }
  },
  async mounted () {
    const { success, data } = await this.miniAppGuideCase({
      guideCaseType: 'CREDIT'
    })
    if (success) {
      const { showGuide } = data
      this.showGuide = showGuide
    }
    this.info()
   
    this.$bus.$emit('ready')
  },
  computed: {
    cycleDay: (state) => state.cycleDay
  },
  methods: {
    ...mapActions(['miniAppGuideCase']),
    ...mapActions('authentication', ['getCreditResultX', 'appletTagX']),
    guideDownload () {
      this.$refs.downloadDialog.init('AUTH_RESULT')
    },
    pulldown () {
      window.location.reload()
    },
    handleAnimation (anim) {
      this.anim = anim
    },
    
    navigateToWithdraw () { 
      wx.miniProgram.postMessage({ data: { eventType: 'WITHDRAW' } })
      wx.miniProgram.navigateBack()
    },
    async info () {
      const { success, data } = await this.getCreditResultX({
        loanPlatform: 'TMD',
        applyNo: this.applyNo
      })
      if (success) {
        this.creditStatus = data.creditStatus
        this.reapplyTime = data.reapplyTime
        this.creditLimit = data.creditLimit
        if (this.creditStatus === 'CREDIT_REVIEW') {
          clearTimeout(window.timer)
          window.timer = setTimeout(() => {
            this.info()
          }, 3000)
        } else {
          this.appletTag()
        }
      }
      this.pageShow = true
    },
    async appletTag () {
      const { success, data } = await this.appletTagX()
      if (success) {
        this.personType = data.crowdTag
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  overflow-y: auto;
}
.question-dialog {
  /deep/.default-content {
    padding-top: 0;
  }

  .question {
    background-image: url(./images/pop_xiazainaedu@2x.png);
    background-position: top;
    background-repeat: no-repeat;
    background-size: 100%;
    width: 620px;
    height: 650px;
    padding-top: 505px;

    .copy-btn {
      width: 320px;
      height: 80px;
      border-radius: 40px;
      font-size: 36px;
      font-weight: 500;
      border: 2px solid #ff4633;
      line-height: 80px;
      text-align: center;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #ff4633;

      img {
        width: 40px;
        height: 40px;
      }

      span {
        padding-left: 10px;
      }
    }
  }
}

.result-mp {
  background: #f7f7f7;
  min-height: 100vh; 
  padding-bottom: 30px; 
}

.refused {
  overflow: hidden;
  padding-top: 283px;

  >img {
    display: block;
    width: 190px;
    height: 190px;
    margin: 0px auto 50px;
  }

  .king-wait {
    width: 162px;
    height: 174px;
    margin: 0 auto;
    background: url(./images/img_wait_clean_king.png) no-repeat;
    background-size: 100%;
    margin-bottom: 20px;

    .badge {
      width: 150px;
      height: 46px;
      background: #ffe2bd;
      border-radius: 20px 100px 100px 0px;
      font-size: 24px;
      font-weight: 400;
      color: #763e12;
      line-height: 46px;
      text-align: center;
      position: absolute;
      top: 259px;
      left: 444px;
    }
  }

  .animation-wapper {
    height: 210px;
    width: 210px;
    margin: 0 auto 50px;
  }

  >h1 {
    font-size: 42px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    text-align: center;
  }

  >p {
    margin-top: 15px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    text-align: center;
  }

  >button {
    display: block;
    width: 320px;
    height: 80px;
    margin: 66px auto 0;
    border-radius: 40px;
    border: 2px solid rgba(255, 70, 51, 1);
    background-color: #fff;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 70, 51, 1);
  }
}

.pass {
  height: 100vh;
  padding: 188px 45px;

  .card {
    overflow: hidden;
    position: relative;
    height: 100%;
    padding: 243px 73px 0;
    background: linear-gradient(180deg,
        rgba(255, 247, 237, 1) 0%,
        rgba(254, 254, 254, 1) 100%);
    border-radius: 30px;

    >img {
      position: absolute;
      top: -90px;
      right: -94px;
      width: 367px;
      height: 367px;
    }

    >h1 {
      font-size: 42px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 59px;
      margin-top: 30px;

      &.underline {
        position: relative;

        &::after {
          position: absolute;
          left: 0;
          bottom: -10px;
          content: "";
          width: 130px;
          height: 10px;
          background: linear-gradient(90deg,
              rgba(255, 179, 92, 1) 0%,
              rgba(253, 122, 22, 1) 100%);
        }
      }
    }

    >p {
      margin-top: 48px;
      font-size: 30px;
      color: rgba(102, 102, 102, 1);
    }

    .solid-button {
      display: block;
      width: 320px;
      height: 80px;
      line-height: 80px;
      border-radius: 40px;
      font-size: 32px;
      margin: 0 auto;
      margin-top: 174px;
      margin-bottom: 40px;
    }

    .text-button {
      display: block;
      width: 320px;
      font-size: 32px;
      color: rgba(255, 70, 51, 1);
      text-align: center;
      margin: auto;
      border: none;
      background: transparent;
    }
  }
}

.guide-result {
  padding-top: 40px;
  position: relative;

  .mp_success {width: 140px;}
  &:before {
    width: 10rem;
    position: absolute;
    content: "";
    height: 582px;
    top: 0;
    background: linear-gradient(180deg,
        #ff4633 0%,
        rgba(255, 255, 255, 0) 100%);
  }

  .card {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 20px;
    margin: 0 30px;
    position: relative;
    justify-content: center;
    align-items: center;
    height: 355px;

    h1 {
      font-size: 36px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 50px;
      margin-top: 15px;
    }

    p {
      margin-top: 10px;
      font-size: 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 37px;

      .red {
        color: #ff4633;
      }
    }
  }

  .info {
    background: #ffffff;
    border-radius: 20px;
    margin: 20px 30px;
    position: relative;
    padding: 30px;

    .header {
      width: 630px;
      height: 70px;
      background:#FFF6ED;
      display: flex;
      align-items: center;
      padding-left: 20px;
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #822b19;

      img {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }
    }

    .info-list {
      margin-top: 50px;

      .item {
        display: flex;
        justify-content: space-between;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-top: 30px;

        b {
          font-size: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
      }
    }

    .btn {
      margin-top: 55px;
      animation: btn 0.5s infinite alternate;
    }

    @keyframes btn {
      to { transform: scale(0.9);}
    }
  }

  .bottom-info {
    width: 368px;
    display: block;
    margin: 100px auto 30px;
  }
}
</style>
